import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

/**
 * Blocks in-app navigation when `hasUnsavedChanges` is true and returns
 * proceed/reset callbacks so the caller can render a custom modal.
 * Also hooks into beforeunload for tab close / refresh.
 */
export function useLeavePrompt(hasUnsavedChanges: boolean) {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      hasUnsavedChanges &&
      currentLocation.pathname !== nextLocation.pathname
  );

  // beforeunload: tab close, refresh, or external navigation
  useEffect(() => {
    if (!hasUnsavedChanges) return;
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges]);

  return {
    isBlocked: blocker.state === 'blocked',
    proceed: () => blocker.state === 'blocked' && blocker.proceed(),
    reset: () => blocker.state === 'blocked' && blocker.reset(),
  };
}
